import { Injectable } from '@angular/core';
import { IDataSourceRequest, IPageSize } from '../models';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

@Injectable({ providedIn: 'root' })
export class HelperService {
  request: IDataSourceRequest = { page: 0, collectionSize: 0, pageSize: 10, searchKeyWord: '' };
  pageSizes: number[] = [5, 10, 20, 50, 100];
  // be uploaded = 1MB
  fileMaxSize: number = 1048576;
  mainPerfectScrollbar: PerfectScrollbarDirective;
  constructor() {}
  // to prevent string and symbol and negative number
  onkeypress(e: any) {
    var input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\s*\.]/.test(input);
  }
}
